import { UUID } from 'eplayer-core'

export default function Card(title) {
  return {
    Type: 'Card',
    objectId: UUID(),
    title: title
  }
}
